import qs from "qs";

const qsEncode = function (str) {
  return encodeURIComponent(str).replace(/%20/g, "-");
};

const qsDecode = function (str) {
  return decodeURIComponent(str).replace(/\-/g, " ");
};
export { qsEncode, qsDecode };
